import React, { useState } from "react";
import { batch, useSelector } from "react-redux";
import { loggedInUser } from "core/redux/slice/authSlice";
import { Link, useNavigate } from "react-router-dom";
import { usePutEmployeeAdvancePaymentList } from "AppQuries/loan/advance-payment";
import AdvancePaymentForm from "Components/Form/AdvancePaymentForm";
import { FormProvider, useForm } from "react-hook-form";
import { getCurrentFormattedDate } from "core/Operations/dateFormat";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { ArrowLeft, Save } from "react-feather";
import { all_routes } from "Router/all_routes";
import { message } from "antd";
import { format } from "date-fns";
import { BackIcon } from "Components/UI/Icon/Icons";
import Select from "react-select";
import YearOption from "Components/Form/YearSelect";
import { useFormattedEmployees } from "core/Operations/formattedOption/useFormattedEmployeeOptions";
import TableTop from "Components/UI/TableTop";
import EmployeeIR8AForm from "./EmployeeForm";

const batchOptions = [
  { value: "O", label: "Original" },
  { value: "R", label: "Amendment" },
  { value: "A", label: "Revision" },
];
const IR8AForm = () => {
  const userData = useSelector(loggedInUser);
  const [isFilterVisible, setIsFilterVisible] = useState(true);
  const [queryParams, setQueryParams] = useState({
    year: new Date().getFullYear(),
    batch: "",
    employeeCode: 0,
  });
  const employeeOptions = useFormattedEmployees({
    companyCode: userData?.companyCode,
    locationCode: userData?.locationCode,
    departmentCode: 0,
  });
  const [employeeCode, setEmployeeCode] = useState(null);
  const navigate = useNavigate();
  const methods = useForm({
    defaultValues: {
      code: 0,
      companyCode: userData?.companyCode,
      isApproved: false,
      balanceAmount: 0,
      paidAmount: 0,
      createUser: userData?.userName,
      modifyUser: userData?.userName,
      modifyDate: getCurrentFormattedDate(),
      createDate: getCurrentFormattedDate(),
      isActive: true,
      advancePaymentDetails: [],
    },
    // resolver: yupResolver(IR8AFormValidationSchema),
  });

  const { mutate: updateAdvancePayment, isPending } =
    usePutEmployeeAdvancePaymentList();

  const onSubmit = (data) => {
    const payload = data;
    payload.balanceAmount = data.advanceAmount;
    payload.repaymentStartDate = data?.repaymentStartDate
      ? format(data.repaymentStartDate, "yyyy-MM-dd")
      : "";
    payload.repaymentEndDate = data?.repaymentStartDate
      ? format(data.repaymentEndDate, "yyyy-MM-dd")
      : "";

    updateAdvancePayment(payload, {
      onSuccess: (data) => {
        console.log(data);
        if (data[0]?.response === true) {
          message.success("Advance Payment Added Successfully");

          setTimeout(() => {
            navigate(
              `${all_routes.advance_payment}${all_routes.advance_payment_list}`,
            );
          }, 1000);
        } else {
          message.warning(data[0].errorMessage);
        }
      },
      onError: (error) => {
        console.log(error.message || "Something went wrong.");
      },
    });
  };

  const generateForm = () => {
    const payload = {
      year: queryParams.year,
      batch: queryParams.batch,
      employeeCode: queryParams.employeeCode,
    };

    console.log("Generating form with payload:", payload);
  };

  const updateQueryParams = (key, value) => {
    setQueryParams((prev) => ({ ...prev, [key]: value }));
  };

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>Generate IR8A Form</h4>
              <h6>Generate IR8A forms for employees</h6>
            </div>
          </div>
          <div className="page-btn">
            <OverlayTrigger
              placement="top"
              overlay={<Tooltip id="add-new-tooltip">Back</Tooltip>}
            >
              <Link
                to={`${all_routes.ir8a_formlist}`}
                className="btn btn-secondary"
              >
                <BackIcon className="me-2" />
                Back
              </Link>
            </OverlayTrigger>
          </div>
          {/* <div className="page-btn">
                  <OverlayTrigger
                    placement="top"
                    overlay={
                      <Tooltip id="add-new-tooltip">Generate Form</Tooltip>
                    }
                  >
                    <button type="submit" className="btn btn-added">
                      {isPending ? (
                        <>
                          <i className="fas fa-spinner fa-spin me-2" /> Loading...
                        </>
                      ) : (
                        <>
                          <Save className="me-2" />
                          Generate
                        </>
                      )}
                    </button>
                  </OverlayTrigger>
                </div> */}
        </div>
        <div className="row">
          <div className="col-md-12">
            <div className="card table-list-card border-0">
              <TableTop
                onSearch={() => {}}
                toggleFilterVisibility={() =>
                  setIsFilterVisible(!isFilterVisible)
                }
                isFilterVisible={isFilterVisible}
                showToggle={true}
              />
              <div
                className={`card${isFilterVisible ? " visible" : ""}`}
                id="filter_inputs"
                // style={{ display: isFilterVisible ? "block" : "none" }}
              >
                <div className="card-body">
                  <div className="form-row row mt-3">
                    <div className="col-lg-3 col-sm-6 col-12 mb-3">
                      <div className="form-group">
                        <label className="form-label">Batch </label>

                        <Select
                          className="select"
                          options={batchOptions}
                          placeholder="Batch"
                          value={batchOptions.find(
                            (option) => option.value === queryParams.batch,
                          )}
                          onChange={(e) => {
                            updateQueryParams("batch", e?.value || 0);
                          }}
                          isClearable
                          menuPortalTarget={document.body}
                          menuPosition="absolute"
                          styles={{
                            control: (baseStyles) => ({
                              ...baseStyles,
                              zIndex: 111,
                            }),
                            menuPortal: (baseStyles) => ({
                              ...baseStyles,
                              zIndex: 9999,
                            }),
                          }}
                        />
                      </div>
                    </div>
                    <div className="col-lg-3 col-sm-6 col-12 mb-3">
                      <div className="form-group">
                        <label className="form-label">Employee </label>

                        <Select
                          className="select"
                          options={employeeOptions}
                          placeholder="Employee"
                          value={employeeOptions.find(
                            (option) =>
                              option.value === queryParams.employeeCode,
                          )}
                          onChange={(e) => {
                            updateQueryParams("employeeCode", e?.value || 0);
                          }}
                          isClearable
                          menuPortalTarget={document.body}
                          menuPosition="absolute"
                          styles={{
                            control: (baseStyles) => ({
                              ...baseStyles,
                              zIndex: 111,
                            }),
                            menuPortal: (baseStyles) => ({
                              ...baseStyles,
                              zIndex: 9999,
                            }),
                          }}
                        />
                      </div>
                    </div>

                    <div className="col-lg-3 col-sm-6 col-12 mb-3">
                      <div className="form-group">
                        <label className="form-label">Year</label>
                        <YearOption
                          selectedYear={queryParams.year}
                          yearSelectHandler={(year) => {
                            updateQueryParams("year", year);
                          }}
                        />
                      </div>
                    </div>

                    <div className="col-lg-3 col-sm-6 col-12">
                      <div className="input-blocks">
                        <label className="form-label">&nbsp;</label>
                        <Link
                          className="btn btn-filters ms-auto"
                          onClick={generateForm}
                          type="button"
                        >
                          <i data-feather="search" className="feather-search" />
                          {/* {isFetching ? (
                          <>
                            <i className="fas fa-spinner fa-spin me-2"></i>
                            Loading...
                          </>
                        ) : ( */}
                          <>Generate</>
                          {/* )} */}
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-12">
            <EmployeeIR8AForm />
          </div>
        </div>
      </div>
    </div>
  );
};

export default IR8AForm;
